import React, { useEffect, useState, useMemo } from "react";
import { FetchDataTypes } from "../../api/api";
import Cookies from "js-cookie";
import { AgGridReact } from "ag-grid-react";
import { GridReadyEvent } from "ag-grid-community";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import { Link } from "react-router-dom";

const Reports = () => {
  const [datalist, setDatalist] = useState<any>();
  const selectedClient:any = Cookies.get("client")
  useEffect(() => {
    FetchDataTypes("Reports", parseInt(selectedClient), Cookies.get("newJwt"))
      .then((response) => response?.json())
      .then((response) => {
        setDatalist(response);
        console.log(response);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

function handleClickName(p:any){
  const { target } = p
  console.log(target);
}

  const defColumnDefs = useMemo(
    () => ({
      sortable: true,
      refreshCells: true,
      //flex:1
    }),
    []
  );
  const [columns, setColumns] = useState([
    {
      headerName: "Report ID",
      field: "reportID",
      width: 90,
    },
    {
      headerName: "Report Name",
      field: "reportName",
      sortable: true,
      width: 250,
      cellRendererFramework: (p: any) => {
        return <Link to={`/portal/reports/${p.data.reportID}`}>{p.data.reportName}</Link>
        
      },
    },
    {
      headerName: "Report Desc",
      field: "reportDesc",
      flex:1
    },
  ]);
  return (
    <div>
      <div className="header">
        <h1 className="header-title">Reports</h1>
      </div>
      <div className="row w-100 card p-4">
        <div
          className="ag-theme-alpine"
          style={{
            height: "500px",
            width: "100%",
          }}
        >
          <AgGridReact
            rowData={datalist}
            columnDefs={columns}
            defaultColDef={defColumnDefs}
            animateRows={true}
            popupParent={document.body}
            pagination={true}
            paginationPageSize={20}
          ></AgGridReact>
        </div>
      </div>
    </div>
  );
};

export { Reports };
